<template>
  <div ref="subGlobal" class="global-main global-shadow">

    <div class='global-panel' v-loading.body="loading.index" style="padding: 10px">
      <div class="global-header">
        <el-page-header @back="goBack" :content="title"></el-page-header>
      </div>
      <div class='global-body'>
        <el-row align="center" v-for="(subject, i) in evalFillList" :key="i">
          <h2 style="text-align:center;">{{subject.subjectName}}</h2>

          <el-card shadow="hover" v-for="(item, j) in subject.fills" :key="j" style="margin: 10px;flex: 1">
            <el-form :model="item" :rules="serverRules" :ref="'form' + i + j" label-width="60px">
              <el-form-item>
                <h3 style="margin:0;">{{++j}}.{{item.evalItem.itemName}}（{{item.evalItem.standard}}）</h3>
              </el-form-item>
              <el-form-item>
                <!--多选框-->
                <el-checkbox-group v-model="item.checkbox" v-if="item.evalItem.itemType==='多选框'">
                  <el-checkbox v-for="option in item.evalItem.options" :label="option.id" :key="option.id" @change="checked=>handleCheckedChange(checked, item, option)">
                    {{option.optionName}}
                  </el-checkbox>
                </el-checkbox-group>
                <!--单选框-->
                <el-radio v-model="item.radio" v-if="item.evalItem.itemType==='单选框'"
                          v-for="option in item.evalItem.options" :label="option.id" :key="option.id" @input="input=>handleRadioInput(input, item, option)">
                  {{option.optionName}}
                </el-radio>
                <!--文本框-->
                <el-input v-model="item.input" v-if="item.evalItem.itemType==='文本框'"></el-input>
              </el-form-item>
              <el-form-item label="附件" v-if="item.evalItem.needAttach">
                <el-select v-model="item.select" multiple placeholder="请选择">
                  <el-option v-for="award in subject.awards" :label="award.name" :value="award.id" :key="award.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="得分" prop="score">
                <el-input-number v-model="item.score" :precision="1" :step="1" :max="item.evalItem.maxScore"></el-input-number>
              </el-form-item>
            </el-form>
          </el-card>
        </el-row>
        <div style="text-align: center;">
          <el-button type="primary" @click="saveEvalFill()" v-show="currentEvalResult.status!=='通过'">保 存</el-button>
          <el-button type="danger" @click="goBack()">返 回</el-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'EvalFill',
  data() {
    return {
      ctrlType: '',
      // 遮罩
      loading: {index: false},
      title: '教职工填报',
      // 当前评优
      currentEval: {},
      currentEvalResult: {},
      // 列表
      evalFillList:[{subjectName:null, awards:[], fills:[{id:null, evalItemId: null, score:null, checkbox:[], radio:null, input:null, select:[], evalItem:{}}]}],
      // 校验规则
      serverRules: {
        score: [
          { required: true, message: '该项必填', trigger: 'change' }
        ]
      },
    }
  },

  /*
   * 初始化
   */
  mounted: function () {
    var vm = this,
        query = vm.$route.query;
    vm.$refs.subGlobal.style.minHeight = (window.innerHeight - vm.$baize.frameTitleHeight) + 'px';
    vm.ctrlType = this.$route.params.ctrlType;
    vm.findEval(query.evalId);
    vm.findEvalResult(query.evalResultId);
    vm.findEvalFill(query.evalId, query.evalResultId);
  },
  beforeRouteUpdate (to, from, next) {
    next()
    this.ctrlType = this.$route.params.ctrlType;
    this.findEval(query.evalId);
    this.findEvalResult(query.evalResultId);
    this.findEvalFill(query.evalId, query.evalResultId);
  },
  methods: {
    goBack: function () {
      var vm = this;
      // 作为正常页面打开
      vm.$router.push({path: '/Eval/'+vm.ctrlType});
    },

    findEval: function (evalId) {
      var vm = this;
      if (evalId) {
        vm.$http.get('rest/eval/findById', {params: {id: evalId}}).then(function (response) {
          // 刷新
          vm.currentEval = response.body;
          vm.title = vm.currentEval.title + ' | 教职工填报';
          // 提示
          // vm.$notify({position: 'bottom-right', type: 'success', message: '查询成功'});
        }, function (response) {
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '查询失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }
    },

    findEvalResult: function (evalResultId) {
      var vm = this;
      if (evalResultId) {
        vm.$http.get('rest/eval/findEvalResultById', {params: {id: evalResultId}}).then(function (response) {
          // 刷新
          vm.currentEvalResult = response.body;
          // 提示
          // vm.$notify({position: 'bottom-right', type: 'success', message: '查询成功'});
        }, function (response) {
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '查询失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }
    },

    findEvalFill: function (evalId, evalResultId) {
      var vm = this;
      vm.evalFillList = [];
      if (evalId) {
        // 开启遮罩
        vm.loading.index = true;
        // 请求后台
        vm.$http.get('rest/eval/findEvalFill', {params: {evalId: evalId, evalResultId: evalResultId}}).then(function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 刷新
          vm.evalFillList = response.body;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '查询成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '查询失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }
    },

    handleCheckedChange: function(checked, item, option) {
      var vm = this;
      if (!item.score) item.score = 0;
      if (checked) {
        item.score += option.score;
      } else {
        item.score -= option.score;
      }
      vm.$forceUpdate();
    },

    handleRadioInput: function(input, item, option) {
      var vm = this;
      if (!item.score) item.score = 0;
      item.score = option.score;
      vm.$forceUpdate();
    },

    saveEvalFill: function () {
      var vm = this;
      var flag = true;
      var data = [];
      for (var i = 0; i < vm.evalFillList.length; i++) {
        data = data.concat(vm.evalFillList[i].fills);
        for (var j = 0; j < vm.evalFillList[i].fills.length; j++) {
          vm.$refs['form' + i + j][0].validate((valid) => {
            if (!valid) {
              flag = false;
            }
          });
        }
      }
      if (flag) {
        // 开启遮罩
        vm.loading.index = true;
        // 请求后台
        vm.$http.post('rest/eval/saveEvalFill', data, {params: {evalId: vm.currentEval.id, staffId:vm.$route.query.staffId}}).then(function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '保存成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })

      } else {
        // 提示信息
        vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
      }
    }

  }
}
</script>

<style>
.global-main {
  padding: 5px 0;
  position: relative;
  overflow: auto;
}

</style>



// WEBPACK FOOTER //
// src/app/EvalFill.vue